import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse, freddyTheme } from '@coolblue-development/freddy';
import selectMoreLessOpeningTimesTrigger from '@coolblue-development/ga4-events/triggers/StoreStockOverlay/selectMoreLessOpeningTimesTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useEffect, useState } from 'react';
import { useStoreAvailability } from '../../../../context/StoreAvailabilityContext.js';
import { useFormatStoreOpeningHours } from '../../../../hooks/useFormatStoreOpeningHours.js';
export const StoreHoursCollapsible = ({ children }) => {
    const { store: { schedules, storeDates }, isSelected, setSelected, timeTravelOverride, } = useStoreAvailability();
    const { trackEvent } = useAnalytics();
    const [open, setOpen] = useState(false);
    const { text: storeOpeningState, isOpen } = useFormatStoreOpeningHours({
        storeDates,
        schedules,
        timeTravelOverride,
    });
    const trackSchedule = () => {
        trackEvent(selectMoreLessOpeningTimesTrigger({ content: 'more' }));
    };
    const handleToggle = (open) => {
        setOpen(open);
        trackSchedule();
        if (open) {
            setSelected();
        }
    };
    useEffect(() => {
        if (!isSelected) {
            setOpen(false);
        }
    }, [isSelected]);
    const collapseTranslations = {
        labelCollapsed: storeOpeningState,
        labelExpanded: storeOpeningState,
    };
    return (_jsx(Collapse, { margin: 0, togglePosition: "top", open: open, translations: collapseTranslations, onToggle: handleToggle, sx: {
            span: {
                color: !isOpen
                    ? freddyTheme.color.font.sentimentNegative
                    : freddyTheme.color.font.sentimentPositiveContrast,
            },
            svg: {
                marginLeft: freddyTheme.spacing[200],
                color: freddyTheme.color.icon.interactiveSubtle,
            },
            button: {
                flexDirection: 'row-reverse',
                alignSelf: 'flex-start',
                '&:hover': {
                    textDecoration: 'none',
                },
            },
        }, children: children }));
};
//# sourceMappingURL=StoreHoursCollapsible.js.map